import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import { MEDIUM_MODAL_WIDTH } from '@constant/size';
import { IAuthCompleteModalData } from '@datatype/iyagigo/type';

interface IProps {
  data: IAuthCompleteModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${MEDIUM_MODAL_WIDTH};
`;

const AuthCompleteModal: React.FC<IProps> = ({ data }) => {
  const { mode } = data;

  const titleText =
    mode === 'signup'
      ? '이야기고에 오신 걸 환영해요'
      : mode === 'remove'
        ? '언제든 다시 만나요'
        : '다시 만나서 반가워요';
  const descriptionText =
    mode === 'signup'
      ? '오늘부터 학습 시작해볼까요?'
      : mode === 'remove'
        ? '함께해 주셔서 감사해요'
        : '오늘도 학습 시작해볼까요?';

  return (
    <Wrapper>
      <TextBlock
        text={titleText}
        design={{
          text: { size: 'medium', color: color.BLACK_2, bold: true },
        }}
      />
      <Gap height={size.MARGIN_1} />
      <TextBlock
        text={descriptionText}
        design={{
          text: { size: 'medium', color: color.BLACK_2, bold: false },
        }}
      />
    </Wrapper>
  );
};

export default AuthCompleteModal;
